import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { IDataPreference } from "@/features/financas/views/Indicadores/@types/type";

export default class Preferencia<T> implements IDataPreference<T> {
  readonly fieldName: string;
  readonly fieldData: T;
  readonly displayName: string;
  readonly id: EWidgets;

  constructor(data: IDataPreference<T>) {
    this.fieldName = data.fieldName;
    this.fieldData = data.fieldData;
    this.displayName = data.displayName;
    this.id = data.id;
  }

  hasData(data: T) {
    if (Array.isArray(data) && data.length == 0) return false;

    return !data;
  }

  hasCompanies(data: string | string[]) {
    if (Array.isArray(data) && data.length == 0) return false;

    return !data;
  }

  createPreferencesData(): IDataPreference<T> {
    return {
      fieldName: this.fieldName,
      fieldData: this.fieldData,
      displayName: this.displayName,
      id: this.id
    };
  }
}
